import { GlobalCurrencyPipe } from '../../shared/pipes/global-currency.pipe';

export function globalCurrency ( globalCurrencyPipe : GlobalCurrencyPipe, sessionObjAPI : any ) {
  return ( value : any, rounding : number, info : any = sessionObjAPI.currency() ) : string => globalCurrencyPipe.transform(value, rounding, info);
};
